/**
 * 浏览器 polyfill：@ton/core 依赖 Buffer，缺失会导致整页白屏（模块求值即崩）。
 */
import { Buffer } from "buffer";

const g = globalThis as typeof globalThis & {
  Buffer?: typeof Buffer;
  process?: { env: Record<string, string> };
};

if (typeof g.Buffer === "undefined") {
  g.Buffer = Buffer;
}
// 部分依赖读 process.env
if (typeof g.process === "undefined") {
  g.process = { env: {} };
}
